import { VITE_SLUG_URL } from '@/utils/runtimeConfig';

const DEFAULT_STOREFRONT_BASE_URL = 'https://nextepay.be';

const normalizeSlug = (slug: string) => slug.trim().toLowerCase();

const getStorefrontBaseUrl = (): URL => {
  const baseUrl = (VITE_SLUG_URL || DEFAULT_STOREFRONT_BASE_URL).trim();
  return new URL(baseUrl);
};

export const buildStorefrontUrl = (slug: string): string => {
  const url = getStorefrontBaseUrl();
  const normalizedSlug = normalizeSlug(slug);
  const baseHostname = url.hostname.replace(/^www\./i, '');
  url.hostname = `${normalizedSlug}.${baseHostname}`;
  url.pathname = '/';
  url.search = '';
  url.hash = '';
  return url.toString();
};
